module.exports = __webpack_public_path__ + "static/img/0007-A-01.d0376a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/audioimg/0007-A-01.jpg
// module id = 9rlt
// module chunks = 0